export const LinkImage = {
  logo: "/logoocop.png",
  vn: "/media/image/vn.png",
  markerDefault: "/media/image/markerBlueIcon.png",
  userDefault: "/userDefault.png",
  pictureDefault: "/default-picture.png",
  common: {
    address: "/media/icon/diaChi.svg",
    calander: "/media/icon/calander.svg",
    status: "/media/icon/trangThai.svg",
    code: "/media/icon/code.svg",
  },
  listDuAn: {
    location: "/media/icon/location.svg",
    career: "/media/image/career.png",
    address: "/media/image/address.png",
  },
  iconPlace: {
    khuCN: "/media/icon/khuCN.svg",
    cumCN: "/media/icon/cumCN.svg",
    khuKinhTe: "/media/icon/industry.svg",
    cho: "/media/icon/cho.svg",
    cuaHangTienLoi: "/media/icon/cuaHangTienLoi.svg",
    cuaHangXangDau: "/media/icon/cuaHangXangDau.svg",
    hiepHoi: "/media/icon/hiepHoi.svg",
    hoi: "/media/icon/hoi.svg",
    hopTacXa: "/media/icon/hopTacXa.svg",
    minimart: "/media/icon/minimart.svg",
    sieuThi: "/media/icon/sieuThi.svg",
    trungTamThuongMai: "/media/icon/trungTamThuongMai.svg",
    dapThuyDien: "/media/icon/dapThuyDien.svg",
    hoChua: "/media/icon/hoChua.svg",
    thuyDien: "/media/icon/thuyDien.svg",
    doanhNghiep: "/media/icon/doanhNghiep.svg",
    duAn: "/media/image/duan.png",
  },
};
